import { createActions } from 'redux-actions';

export const {
  editGuestProtocol,
  updateProtocolDays,
  updateSessionLabels,
  removeGuestProtocol,
  updateGuestProtocols,
  updateProtocolsFocus,
  updateProtocolInstructions,
} = createActions(
  'EDIT_GUEST_PROTOCOL',
  'UPDATE_PROTOCOL_DAYS',
  'UPDATE_SESSION_LABELS',
  'REMOVE_GUEST_PROTOCOL',
  'UPDATE_GUEST_PROTOCOLS',
  'UPDATE_PROTOCOLS_FOCUS',
  'UPDATE_PROTOCOL_INSTRUCTIONS',
);
